export default __webpack_public_path__ + "static/media/royce-hall.b09b9f25.png";